import { PopupProps } from './types';
import { StyledPopup } from './styles';

const Popup = ({ ...props }: PopupProps): JSX.Element => {
  return <StyledPopup {...props}>{props.children}</StyledPopup>;
};

export { Popup };
